import React, { useContext } from 'react';

import axios from 'axios';

import { Answer, Question } from '~/types';
import Fade from '~/components/Fade';
import { useTranslation } from 'react-i18next';
import StyledDropDown from '~/components/StyledDropdown';
import * as topicUtils from '~/util/topic';

import { AppContext } from '~/contexts/AppContext';
import { QuestionContext } from '~/contexts/QuestionContext';
import MatomoTracker from '~/util/matomo/MatomoTracker';
import { useParams } from 'react-router-dom';

export type SetImageFunction = (i: number, imageUrl: string) => void;
export type DeleteImageFunction = (i: number) => void;

const DropdownAnswer: React.FC = () => {

    const { t, i18n } = useTranslation();

    const { topicData, apiUrl, preciseCoordinates } = useContext(AppContext)!;
    const { ratingId, question, questionTime, onSubmitAnswer } = useContext(QuestionContext)!;

    const params: { topicHash: string } = useParams();

    const submitAnswer = async (e: React.ChangeEvent<HTMLSelectElement>, answer: Answer) => {

        await axios.post(`${apiUrl}/rating-answer/${topicData?.topic.id}/dropdown`, {
            ratingId: ratingId,
            questionnaireId: question.questionnaireId,
            questionId: question.questionId,
            preciseCoordinates: preciseCoordinates,
            timeToAnswerMs: !questionTime ? 0 : Date.now() - questionTime,
            lang: i18n.language,
            answerText: e.target.value
        });

        MatomoTracker.trackEvent({
            category: 'qna', 
            action: 'submit-answer',
            documentTitle: topicData?.topic.name,
            href: `https://kazva.bg/${params.topicHash}`,
            customDimensions: [
                { id: 3, value: question.questionText },
                { id: 4, value: e.target.value },
                { id: 5, value: '' }
            ]
        });

        onSubmitAnswer(answer.nextQuestionId ?? null);
    };

    const separateValues = (valuesString: string) => {
        return valuesString.split(';').map(str => str.trim());
    };

    return (
        <Fade>
            {question.answers.map((answer: Answer, i: number) =>
                <StyledDropDown key={i} style={{ fontSize: '16px', padding: '17px 20px', marginLeft: '-6px', width: 'calc(100% + 12px)' }} onChange={(e) => submitAnswer(e, answer)} value={t('label_please_choose')}>
                    <option disabled>{t('label_please_choose')}</option>
                    {separateValues(topicUtils.getAnswerText(
                        topicData,
                        question.questionId,
                        answer.answerId,
                        i18n.language
                    )).map((value: string, optionIndex: number) => 
                        <option key={optionIndex} value={value}>{value}</option>
                    )}
                </StyledDropDown>
            )}
        </Fade>
    );
};

export default DropdownAnswer;